import * as dateFnsCompat from 'utils/date-fns-compat';

import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { Thumbnail } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import { compose, withProps, withStateHandlers } from 'recompose';
import 'slick-carousel/slick/slick.css';
import { dateFormats, routes } from '../../../../constants';
import { getUserIndustryGoals, tileCpdCategoryClassName } from '../../../../services';
import { pluralise } from '../../../../utils';
import Tooltip from '../../../components/tooltip';
import { TooltipWrapper } from './tooltip-wrapper';
import { UnspecifiedCpdCategory } from './unspecified-cpd-category';

const EventTile = ({
  altText,
  fullCpdCategory,
  category,
  publisher,
  cpdPoints,
  date,
  duration,
  image,
  imageSet,
  title,
  venue,
  suburb,
  eventRoute,
  price,
  registered,
  isTasaCpd,
  onTruncate,
  truncated,
  description,
  goals,
  userIndustryGoals,
  ignoreStartTime,
  ignoreDuration
}) => (
    <div className='tile event'>
      <header>
        <div className='title-header'>
          {
            registered ? <div className="cpd-progress-banner registered">registered</div> : null
          }
          <LinkContainer to={eventRoute}>
            <Thumbnail src={image} srcSet={imageSet} alt={altText} />
          </LinkContainer>
        </div>
      </header>
      <main>
        <div className='category'>
          {
            category ?
              category === 'Pending' ?
                <UnspecifiedCpdCategory /> :
                <TooltipWrapper
                  className={isTasaCpd ? 'fixed-cat' : tileCpdCategoryClassName(category)}
                  category={category}
                  fullCpdCategory={fullCpdCategory}
                  trigger={['hover', 'focus']}
                /> :
              <span className='publisher'>{publisher}</span>
          }
          {
            fp.flow(
              fp.filter(
                ({ id }) => fp.contains(id)(goals)
              ),
              fp.map(
                ({ id, name }) => <span key={id} className='cat'>
                  {
                    fp.first(fp.split(' ')(name))
                  }
                </span>
              )
            )(userIndustryGoals)
          }
          <FontAwesome name='calendar-o' className='icon' />
        </div>
        {category ? <div className='publisher'>{publisher}</div> : null}
        <div className='title'>
          <Link to={eventRoute}>{title}</Link>
        </div>
        <span className='description' alt={description}>
          <Tooltip
            disabled={!truncated}
            placement='bottom'
            component={
              <Truncate onTruncate={onTruncate} lines={2} ellipsis={<a className='action'>...Read More</a>}>
                {description}
              </Truncate>
            } tip={<p className='padding-thin tip'>{description}</p>} />
        </span>
        <span className='date-time'>
          {
            dateFnsCompat.format(
              date,
              ignoreStartTime ? dateFormats.ShortDate : dateFnsCompat.getMinutes(date) === 0 ? dateFormats.Short12hourClockDateHour : dateFormats.Short12hourClockDateTime
            )
          }
        </span>
      </main>
      <footer>
        <span className='time'>{duration}</span>
        {cpdPoints ? <span className='points'>{`${cpdPoints} CPD ${pluralise('hour', cpdPoints)}`}</span> : null}
        {suburb ? <span className='venue'>{suburb}</span> : null}
        {
          price > 0 ?
            <span className='price'>Fr. ${price}</span> :
            <span className='price'>FREE</span>
        }
      </footer>
    </div>
  );

EventTile.propTypes = {
  altText: PropTypes.string,
  category: PropTypes.string,
  duration: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string,
  id: PropTypes.number,
  isTasaCpd: PropTypes.bool
};

const mapStateToProps = ({ user, industry }) => ({
  userIndustryGoals: getUserIndustryGoals(user.profile, fp.get('industriesWithCpdCategorys')(industry))
})

const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      truncated: false
    },
    {
      onTruncate: () => (truncated) => ({
        truncated
      })
    }
  ),
  withProps(
    ({ id, externalCpdRecordsForUser }) => ({
      eventRoute: {
        pathname: routes.app.training.event, search: `?${queryString.stringify({ eventId: id })}`
      },
      registered: externalCpdRecordsForUser.length > 0
    })
  )
)(EventTile);


// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/event-tile.js